var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 345,
    height: 405,
    viewBox: "0 0 345 405",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_22808_4914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8207 76.8502C25.8807 154.437 22.4609 196.752 20.7976 261.071C23.1843 286.056 27.7249 296.852 45.7775 306.145C118.415 337.395 169.094 361.451 228.549 384.048C253.603 386.669 263.347 381.31 273.169 367.773C293.366 318.162 303.156 262.253 322.226 191.999C327.103 164.586 323.087 152.679 302.784 138.093C227.167 94.2136 116.875 33.352 116.875 33.352C116.875 33.352 96.0405 19.7999 82.5633 20.8509C66.5943 23.685 59.2299 28.1534 49.5743 37.8912C38.3984 49.409 34.7589 57.9507 32.8207 76.8502Z",
    fill: "#652784"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_22808_4914",
    x: 0.796875,
    y: 0.792786,
    width: 343.305,
    height: 403.9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22808_4914"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22808_4914",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftPurple);
export default __webpack_public_path__ + "static/media/LeftPurple.4b1853ce70a7f2398661cb8f8445b455.svg";
export { ForwardRef as ReactComponent };